export const mutations = {
  /**
   * @param {*} state
   * @param {array} staffs
   */
  setStaff(state, staffs) {
    state.staffs = staffs;
  },
};
